 <template>
  <div class="date-wrapper">
    <div class="title">{{ title }}</div>
    <hr :style="`background-color:${color}`" />
    <div class="date">{{ date }}</div>
  </div>
</template>
 
 
 <script>
export default {
  name: 'dates',
  props: {
    color: {
      type: String,
    },
    date: {
      type: String,
    },
    title: {
      type: String,
    },
  },
}
</script>
 <style scoped lang='scss'>
.date-wrapper {
  display: flex;
  align-items: center;
  .title {
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 21px;
    letter-spacing: 0px;
  }
  .date {
    font-size: 11px;
    font-style: normal;
    font-weight: 400;
    line-height: 21px;
    letter-spacing: 0px;
    color: #999999;
  }
  hr {
    width: 3px;
    height: 18px;
    border-radius: 10px !important;
    margin: 0 10px;
    opacity: 1 !important;
  }
}
</style>